import React from "react";
import "@/App.css";
import Hero from "@/components/Hero";
import Header from "@/components/Header";
import LogoSection from "@/components/LogoSection";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Portfolio from "@/components/Portfolio";
import Blog from "@/components/Blog";
import SoroBlog from "@/components/SoroBlog";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEO from "@/components/SEO";
import { Toaster } from "@/components/ui/sonner";
import { services, portfolioImages, testimonials } from "@/mock";

function App() {
  return (
    <div className="App">
      <SEO />
      <Header />
      <Hero />
      <LogoSection />
      <div id="services">
        <Services services={services} />
      </div>
      <div id="portfolio">
        <Portfolio portfolioImages={portfolioImages} />
      </div>
      <div id="pricing">
        <Pricing />
      </div>
      <div id="blog">
        <SoroBlog />
      </div>
      <Testimonials />
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

export default App;

